import type { DefaultMenuItem, GetMainMenuItemsParams, GridApi, MenuItemDef } from "ag-grid-community";

let wrapHeaderTextEnabled = false;

export const getWrapHeaderTextEnabled = () => wrapHeaderTextEnabled;

const toggleWrapHeaderTextWithApi = (enabled: boolean, api: GridApi) => {
  api.getColumns()?.forEach((column) => {
    const def = column.getColDef();
    def.wrapHeaderText = enabled;
    def.autoHeaderHeight = enabled;
  });
  api.setGridOption("headerHeight", enabled ? undefined : 27);
  api.setGridOption("groupHeaderHeight", enabled ? undefined : 27);
  api.refreshHeader();
};

export const wrapHeaderMenuItems = (params: GetMainMenuItemsParams): (MenuItemDef | DefaultMenuItem)[] => {
  const wrapHeaderText = wrapHeaderTextEnabled;

  return [
    {
      name: wrapHeaderText ? "Disable Wrapped Headers" : "Enable Wrapped Headers",
      action: () => {
        const next = !wrapHeaderText;
        wrapHeaderTextEnabled = next;
        toggleWrapHeaderTextWithApi(next, params.api);
      },
      icon: `<div class="context-menu-icon-container"><span class="material-symbols-rounded context-menu-icon">wrap_text</span></div>`,
    },
  ];
};
